<!-- 基础chart -->
<template>
  <section
    ref="canvas"
    :style="{ width, height }"
  ></section>
</template>

<script setup lang="ts">
  import {
    ref, watch, onUnmounted, onMounted, shallowRef,
  } from 'vue';
  import { useDebounceFn } from '@vueuse/core';
  import * as echarts from 'echarts';

  const props = defineProps({
    autoResize: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  });

  const canvas = ref(null);
  const instance = shallowRef<any>(null);

  const resizeHandle = () => {
    if (instance.value) {
      instance.value.showLoading();

      instance.value.resize();
      instance.value.hideLoading();
    }
  };

  const debounceFunction = useDebounceFn(resizeHandle, 300);

  const initCharts = () => {
    instance.value = echarts.init(canvas.value);
    instance.value?.setOption(props.options);
    if (props.autoResize) {
      window.addEventListener('resize', debounceFunction);
    }
  };

  watch(() => props.options, (val) => {
    if (val && val.series?.length && instance) {
      instance.value?.setOption(val, true);
    }
  }, {
    immediate: true,
  });

  onMounted(() => {
    initCharts();
  });

  onUnmounted(() => {
    if (props.autoResize) {
      window.removeEventListener('resize', debounceFunction);
    }
    if (instance.value) {
      instance.value.dispose();
    }
  });
  defineExpose({
    instance,
  });
</script>

<style lang='scss' scoped>

</style>
